import { ActionTypes } from './action-types.enum';

const initialState = {
  categoryId: '',
  images: [],
};

const addUploadedImg = (state, action) => {
  const { images } = state;
  const imageIndex = images
    .findIndex((img) => (img.fileId && img.fileId === action.payload?.fileId));

  if (imageIndex >= 0) {
    images[imageIndex] = {
      ...action.payload?.image,
      isUploading: false,
    };
  }

  return {
    ...state,
    images: [...images],
  };
};

const addProcessedImg = (state, action) => {
  const { images } = state;
  const imageIndex = images
    .findIndex((img) => (img.id && img.id === action.payload?.id));

  if (imageIndex >= 0) {
    images[imageIndex] = {
      ...action.payload,
      isUploading: false,
      isProcessing: false,
      detectedObjectsSummary: action.payload.detectedObjectsSummary,
      createdAt: action.payload.createdAt,
    };
  }

  return {
    ...state,
    images: [...images],
  };
};

const addProcessingImg = (state, action) => {
  const { images } = state;
  const imageIndex = images
    .findIndex((img) => (img.fileId && img.fileId === action.payload?.fileId));

  if (imageIndex >= 0) {
    images[imageIndex] = {
      id: action.payload?.id,
      isUploading: false,
      isProcessing: true,
    };
  }

  return {
    ...state,
    images: [...images],
  };
};

const updateObjectCount = (state, action) => {
  const { images } = state;
  const imageIndex = images
    .findIndex((img) => (img.id && img.id === action.payload?.id));

  if (imageIndex >= 0) {
    images[imageIndex] = {
      ...images[imageIndex],
      detectedObjectsSummary: [{
        type: images[imageIndex].detectedObjectsSummary?.[0]?.type ?? '',
        count: action.payload.count,
      }],
    };
  }

  return {
    ...state,
    images: [...images],
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.ADD_IMAGES:
      return {
        categoryId: action.payload?.categoryId,
        images: action.payload?.images || state.images,
      };
    case ActionTypes.ADD_UPLOADING_IMAGES:
      return {
        ...state,
        images: [...state.images, ...action.payload?.images],
      };
    case ActionTypes.ADD_IMAGE:
      return {
        ...state,
        images: action.payload?.image ? [...state.images, action.payload?.image] : state.images,
      };
    case ActionTypes.ADD_UPLOADED_IMAGE:
      return addUploadedImg(state, action);
    case ActionTypes.ADD_PROCESSING_IMAGE:
      return addProcessingImg(state, action);
    case ActionTypes.ADD_PROCESSED_IMAGE:
      return addProcessedImg(state, action);
    case ActionTypes.UPDATE_OBJECT_COUNT:
      return updateObjectCount(state, action);
    case ActionTypes.DELETE_UPLOADED_IMAGE:
      return {
        ...state,
        images: state.images?.filter((el) => el.fileId !== action.payload?.fileId),
      };
    case ActionTypes.DELETE_IMAGE:
      return {
        ...state,
        images: state.images?.filter((el) => el.id !== action.payload?.id),
      };
    default:
      return state;
  }
};
